// extracted by mini-css-extract-plugin
module.exports = {"search":"styles_search__2OQfx"};